import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  deleteCartItems,
  deleteProductionCart,
  fetchProductionCart,
} from "../../api/thunks";
import { CartProductType, CartSliceState } from "../types";

export const addProductionExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(fetchProductionCart.pending, (state) => {
    state.isLoadingProd = true;
    state.error = null;
  });
  builder.addCase(
    fetchProductionCart.fulfilled,
    (
      state,
      action: PayloadAction<
        { items: CartProductType[]; totalCount: number } | undefined
      >,
    ) => {
      if (!action.payload) return;

      const filteredProducts = action.payload?.items
        .map((product) => ({
          ...product,

          basketFilials: product.basketFilials.filter((bf) => bf.quantity > 0),
        }))

        .filter((product) => product.basketFilials.length > 0);

      const { ids, totalProdCount, basketIds, filialIds } =
        filteredProducts.reduce(
          (
            acc: {
              ids: string[];
              totalProdCount: number;
              basketIds: string[];
              filialIds: string[];
            },
            product,
          ) => {
            acc.ids.push(product.vendorId);

            const prodQty = product.basketFilials.reduce(
              (sum, bf) => sum + bf.quantity,
              0,
            );
            acc.totalProdCount += prodQty;

            product.basketFilials.forEach((bf) =>
              acc.basketIds.push(bf.basketId),
            );
            const filials = [
              ...new Set([
                ...acc.filialIds,
                ...product.basketFilials.map((bf) => bf.dealerId),
              ]),
            ];
            acc.filialIds = filials;
            return acc;
          },
          { ids: [], totalProdCount: 0, basketIds: [], filialIds: [] },
        );

      state.error = null;
      state.allProdIds = ids;
      state.totalProdCount = totalProdCount;
      state.allBasketProdIds = basketIds;
      state.allFilialsProdIds = filialIds;
      state.productionItems = filteredProducts;
      state.productionTotalPageNumber = action.payload.totalCount;
      state.isLoadingProd = false;
    },
  );
  builder.addCase(fetchProductionCart.rejected, (state, action) => {
    if (!action.meta.aborted) {
      state.error = action.payload;
      state.isLoadingProd = false;
    }
  });

  builder.addCase(deleteProductionCart.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(deleteProductionCart.fulfilled, (state) => {
    state.error = null;
    state.isLoading = false;
    state.allProdIds = [];
    state.productionItems = [];

    state.productionPageNumber = 0;
    state.productionTotalPageNumber = 0;
  });
  builder.addCase(deleteProductionCart.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(deleteCartItems.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(deleteCartItems.fulfilled, (state) => {
    state.error = null;
    state.isLoading = false;
    state.allProdIds = [];

    const itemsP = state.productionItems.filter(
      (product) => !state.selectedProdItems.includes(product.vendorId),
    );

    state.productionItems = itemsP;
    state.selectedProdItems = [];
  });

  builder.addCase(deleteCartItems.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });
};
